import React from "react";
import { motion } from "framer-motion";

const Help = () => {
  return (
    <div className="max-w-7xl mx-auto px-10 pb-10">
      <h1 className="text-xl sm:text-2xl font-bold text-center mb-6 text-gray-800 border border-gray-800 rounded-2xl py-3">
        Help
      </h1>

      <p className="text-center text-sm text-gray-700 italic mb-16">
        "Help will always be given at{" "}
        <span className="text-mainColor">Academy-nest</span> to those who ask
        for it." - Some Professor
      </p>

      {/* FAQs Section */}
      <section className="mb-16">
        <h2 className="text-lg font-semibold mb-6 text-gray-800">
          Frequently Asked Questions (FAQs)
        </h2>
        <div className="space-y-6">
          {[
            {
              question: "What is this platform?",
              answer:
                "This platform allows teachers to conduct live courses, and students who enroll can attend live sessions once the session time is reached.",
            },
            {
              question: "How do I enroll in a course?",
              answer:
                "Navigate to the enrollment page, choose a category, select a course, and click 'Get Started.' Pick a suitable time and teacher, make the payment, and wait for admin approval.",
            },
            {
              question: "How do I make a payment?",
              answer:
                "Payments can be made via Stripe or locally using your CBE account.",
            },
            {
              question: "What happens after payment?",
              answer:
                "Admin reviews your application and approves your enrollment. Upon approval, you will receive a notification to join the live session at the scheduled time.",
            },
          ].map((faq, index) => (
            <details
              key={index}
              className="bg-black p-5 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <summary className="cursor-pointer text-base font-medium text-gray-200">
                {faq.question}
              </summary>
              <p className="mt-6 text-gray-300">{faq.answer}</p>
            </details>
          ))}
        </div>
      </section>

      {/* Step-by-Step Timeline Section */}
      <section className="mb-16">
        <h2 className="text-lg font-semibold mb-6 text-gray-800">
          Step-by-Step Timeline
        </h2>
        <motion.ol
          className="list-decimal pl-8 space-y-4 text-lg text-gray-700"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          {[
            "Navigate to Enrollment Page",
            "Choose a Course",
            "Select Time and Teacher",
            "Make a Payment",
            "Admin Approval",
            "Live Session Notification",
          ].map((step, index) => (
            <motion.li
              key={index}
              className="transition-transform duration-300 ease-in-out text-base"
              whileHover={{ scale: 1.02 }}
            >
              {step}
            </motion.li>
          ))}
        </motion.ol>
      </section>

      {/* Contact Support Section */}
      <section className="mb-16">
        <h2 className="text-lg font-semibold mb-6 text-gray-800">
          Contact Support
        </h2>
        <p className="text-base text-gray-700 leading-relaxed">
          Need more help? Reach out to us at{" "}
          <a
            href="mailto:ecybernest@gmail.com"
            className="text-blue-500 underline hover:text-blue-600 transition-colors"
          >
            Ecybernest@gmail.com
          </a>{" "}
          or use the contact feature on the platform. We're here to assist you!
        </p>
      </section>
    </div>
  );
};

export default Help;
